import React from 'react';
import Groups from './index';
import ErrorBoundary from '../../../components/ErrorBoundary';
import HelpButton from '../../../components/HelpButton';

const AdminNotifications = React.lazy(() => import('./AdminNotifications'));

const AdminNotificationsPage = (props) => (
  <Groups scrolling>
    <div className="text-right">
      <HelpButton fileName="notifications-groups-and-users" />
    </div>
    <ErrorBoundary>
      <React.Suspense fallback={<div />}>
        <AdminNotifications {...props} />
      </React.Suspense>
    </ErrorBoundary>
  </Groups>
);

export default AdminNotificationsPage;
